import React, { useEffect, useState } from "react";
import { Modal, Button, ProgressBar, Row, Col } from "react-bootstrap";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { formatDate } from "../../utils/formatDate";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";

function ValidateProductionLog({ show, handleClose, logId ,productionDate,shift}) {
  const [loading, setLoading] = useState(false);
  const [operatorProductionLog, setOperatorProductionLog] = useState(null);
  const [qtyAccepted, setQtyAccepted] = useState("");
  const [qtyRejected, setQtyRejected] = useState("");
  const [qtyHold, setQtyHold] = useState("");
  const [notes, setNotes] = useState("");
  const fetchOperatorProductionLog = async () => {
  const token = getAuthToken();
  if (!token) return;
  try {
    setLoading(true);
    const response = await axios.post(
      `${config.API}/supervisor/operatorproductionlogget/${logId}`,
      {
        date:productionDate,
        shift:shift  
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setOperatorProductionLog(response?.data || []);
    console.log(response?.data);
    toast.success("Operator production log fetched successfully");

  } catch (err) {
    console.error("Error fetching operator production log:", err);
    setOperatorProductionLog([]); 
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    if (show && logId) fetchOperatorProductionLog();
  }, [show, logId]);
  const logData = operatorProductionLog?.production_log?.[0] || {};
  const products = operatorProductionLog?.product || [];
  const totalUnits = Number(operatorProductionLog?.target || 0);
  const producedUnits = Number(logData.total_units_produced || 0);
  const efficiency =
    totalUnits > 0 ? ((producedUnits / totalUnits) * 100).toFixed(2) : 0;

  const operatorproductionlog = async () => {
    const token = getAuthToken();
    if (!token) return;

    const payload = {
      date:productionDate,
      units_produced: producedUnits,
      unit_rejected: Number(qtyRejected || 0),
      unit_hold: Number(qtyHold || 0),
      units_accepted: Number(qtyAccepted || 0),
      target_units: totalUnits,
      non_conformities: Number(logData.total_units_rejected || 0),
      notes: notes,
      shift:shift
    };

    try {
      setLoading(true);
      const response = await axios.post(
        `${config.API}/supervisor/operatorproductionlog/${logId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message);
      handleClose();
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Error submitting production log");
    } finally {
      setLoading(false);
    }
  };

const adjustedDate = new Date(productionDate);
if (shift === "Night") {
  adjustedDate.setDate(adjustedDate.getDate());
}

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered className="font_family">
      <Modal.Header closeButton>
        <h4 className="fw-bold">Operator Production Log</h4>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="d-flex justify-content-between">
              <div>
                <span><strong>Operator Name:</strong> {operatorProductionLog?.operator?.name}</span> <br/>
                <strong>Date:</strong> {formatDate(adjustedDate)} <br/>
                <strong>Shift:</strong> {shift}
              </div>
              <div className="text-end">
                <h5 className="text-primary fw-bold">{efficiency}%</h5>
                <small>Efficiency</small>
              </div>
            </div>

            <hr />

            <div className="d-flex justify-content-between mb-2">
              <h6 className="fw-bold">Production Summary</h6>
              <small>{producedUnits}/{totalUnits}</small>
            </div>

            <ProgressBar now={Number(efficiency)} className="mb-4"  style={{ height: "6px" }} />

            <Row className="text-center mb-4">
              <Col>
                <div className="bg-light p-3 rounded">
                  <h4 className="fw-bold">{producedUnits}</h4>
                  <small>Units Produced</small>
                </div>
              </Col>
              <Col>
                <div className="bg-light p-3 rounded">
                  <h4 className="fw-bold">{totalUnits}</h4>
                  <small>Target Units</small>
                </div>
              </Col>
              <Col>
                <div className="bg-light p-3 rounded">
                  <h4 className="fw-bold">{logData.total_units_rejected || 0}</h4>
                  <small>Non-Conformities</small>
                </div>
              </Col>
            </Row>

            <h6 className="fw-bold mb-3">Product Breakdown</h6>
            {products.map((item, idx) => {
              const productEfficiency =
                item?.total_units > 0
                  ? ((item.total_units_produced / item.total_units) * 100).toFixed(2)
                  : 0;

              return (
                <div key={idx} className="mb-3">
                  <div className="d-flex justify-content-between">
                    <span>{item?.product?.name}</span>
                    <span>{item?.total_units_produced}/{item?.total_units}</span>
                  </div>
                  <ProgressBar now={Number(productEfficiency)}  style={{ height: "6px" }}/>
                </div>
              );
            })}

            <Row>
              <Col md={4}>
                <label className="fw-bold">Qty Accepted</label>
                <input type="text" className="form-control"
                  value={qtyAccepted}
                  onChange={(e) => setQtyAccepted(e.target.value)}
                />
              </Col>
              <Col md={4}>
                <label className="fw-bold">Qty Rejected</label>
                <input type="text" className="form-control"
                  value={qtyRejected}
                  onChange={(e) => setQtyRejected(e.target.value)}
                />
              </Col>
              <Col md={4}>
                <label className="fw-bold">Qty Hold</label>
                <input type="text" className="form-control"
                  value={qtyHold}
                  onChange={(e) => setQtyHold(e.target.value)}
                />
              </Col>
            </Row>

            <div className="mt-3">
              <label className="fw-bold">Notes</label>
              <textarea
                className="form-control"
                rows="3"
                value={notes}
                required
                onChange={(e) => setNotes(e.target.value)
                }
              />
            </div>

            <div className="text-end mt-4">
              <Button variant="dark" onClick={operatorproductionlog}>
                Submit
              </Button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ValidateProductionLog;